import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/userconfigurevip/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/userconfigurevip/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/userconfigurevip/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/userconfigurevip/submit',
    method: 'post',
    data: row
  })
}

export const saveExcel = (data) => {
  return request({
    url: '/user/userconfigurevip/excel/save',
    method: 'post',
    file: data
  })
}

export const moduleExcel = () => {
  return request({
    url: '/user/userconfigurevip/excel/download',
    method: 'get',
    responseType: 'blob'
  })
}
